import CollectionView from 'views/base/collection-view';
import BlocksTemplate from './templates/blocks';
import _ from 'lodash';

const BlocksView = CollectionView.extend({
  animationDuration: 0,
  autoRender: true,
  noWrap: true,
  template: BlocksTemplate,
  listen: {
    addedToDOM: 'loaded',
  },
  initialize: function (options) {
    this.parent = options.parent;
    this.options = options;
    this.templateData = options.templateData;
    this.pageView = options.pageView;
    this.listenTo(this.parent, 'page:state:change', this.stateChange);
    this.listenTo(this.parent, 'block:state:completed', this.stateChange);
    CollectionView.prototype.initialize.apply(this, arguments);
  },
  getTemplateData: function () {
    return this.templateData;
  },
  stateChange: function (parent) {
    //proxy page state change through to child blocks
    this.trigger('page:state:change', parent);
  },
  initItemView: function (model) {
    let BlockType = require(`views/block/${model.get('type')}/${model.get('type')}-view`);
    const options = {
      autoRender: false,
      script: this.options.script,
      model: model,
      parent: this,
      pageView: this.pageView,
    };
    if (model.get('class')) {
      options.className = BlockType.default.prototype.className
        ? `${BlockType.default.prototype.className} ${model.get('class')}`
        : model.get('class');
    }
    // some blocks use es6 export, some dont
    if (BlockType.default) {
      BlockType = BlockType.default;
    }
    const blockView = new BlockType(options);
    this.listenTo(blockView, 'block:state:loaded', block => {
      if (this.isLoaded()) {
        this.trigger('block:state:loaded', this);
      }
    });
    this.listenTo(blockView, 'block:state:completed', function (block) {
      this.trigger('block:state:completed', block);
    });
    return blockView;
  },
  isLoaded: function () {
    if (this.subviews) {
      return _.every(this.subviews, function (subview) {
        return subview.isLoaded();
      });
    } else {
      return true;
    }
  },
  loaded: function () {
    if (this.options.collection.forge_path) {
      this.$el.attr('data-collection-path', this.options.collection.forge_path);
    }
  },
  isComplete: function () {
    if (this.subviews) {
      return _.every(this.subviews, function (subview) {
        return subview.isComplete();
      });
    } else {
      return true;
    }
  },
});

export default BlocksView;
